import { useEffect, useState } from 'react';

const EARLY_JOIN_MS = 5 * 60 * 1000;

interface CountdownResult {
    readonly days: number;
    readonly hours: number;
    readonly minutes: number;
    readonly seconds: number;
    readonly isLive: boolean;
    readonly canJoin: boolean;
    readonly displayText: string;
}

function computeCountdown(eventDate: string): CountdownResult {
    const now = Date.now();
    const target = new Date(eventDate).getTime();
    const diff = target - now;

    if (diff <= 0) {
        return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            isLive: true,
            canJoin: true,
            displayText: ''
        };
    }

    const canJoin = diff <= EARLY_JOIN_MS;

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    const parts: string[] = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);
    parts.push(`${minutes}m`);

    return { days, hours, minutes, seconds, isLive: false, canJoin, displayText: parts.join(' ') };
}

export function useCountdown(eventDate: string): CountdownResult {
    const [countdown, setCountdown] = useState<CountdownResult>(() => computeCountdown(eventDate));

    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown(computeCountdown(eventDate));
        }, 1000);

        return () => clearInterval(interval);
    }, [eventDate]);

    return countdown;
}
